<template>
  <marked class="markdown-container" :sourceList="sourceList" :content="content"></marked>
</template>

<script>
import marked from './mark-down.umd.min.js'
import './mark-down.css'
export default {
  name: 'MarkDown',
  components: {
    marked
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    sourceList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
